import React, { useMemo } from "react";
import Collapsable from "../custom/Collapsable";
import Box from "@material-ui/core/Box";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import renderHTML from "lib/render-html";
import { hasHTMLTags } from "lib/helpers";

const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    margin: "16px 0px",
    "&:not(:last-child)": {},
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      marginTop: 16,
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles((theme) => ({
  root: {
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "12px 0",
      color: theme.palette.primary.main,
    },
  },
  expandIcon: {
    "&$expanded": {
      transform: "unset",
    },
  },
  expanded: {},
}))(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

const useStyles = makeStyles((theme) => ({
  root: {},
  list: {
    padding: 0,
    paddingLeft: theme.spacing(1.5),
    margin: 0,
    // listStyle: "none",
    "& li": {
      // borderLeft: "3px solid",
      paddingLeft: 8,
      margin: theme.spacing(0.5, 0),
    },
    // "& li:nth-child(even)": {
    //   borderColor: theme.palette.success.main,
    // },
    // "& li:nth-child(odd)": {
    //   borderColor: theme.palette.primary.main,
    // },
  },
}));

const CourseAgenda: React.FC<CourseAgendaProps> = ({ content }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const data = useMemo(() => {
    return {
      heading: content.topic_name,
      subHeading: content.sub_heading,
      contents: content.contents,
    };
  }, [content]);
  return (
    <Collapsable heading={data.heading} isOpen={true}>
      <Box className={classes.root}>
        {data.contents?.map((item, index) => (
          <Accordion
            key={`panel-${index}`}
            square
            expanded={expanded === `panel${index + 1}`}
            onChange={handleChange(`panel${index + 1}`)}
          >
            <AccordionSummary
              aria-controls={`panel${index + 1}d-content`}
              id={`panel${index + 1}d-header`}
              expandIcon={
                expanded === `panel${index + 1}` ? <RemoveIcon /> : <AddIcon />
              }
            >
              <Typography>{item.heading}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {item.list.length > 1 ? (
                <ul className={classes.list}>
                  {item.list.map((litem, index) => (
                    <li key={index}>{renderHTML(litem)}</li>
                  ))}
                </ul>
              ) : hasHTMLTags(item.list[0]) ? (
                renderHTML(item.list[0])
              ) : (
                <Typography>{item.list[0]}</Typography>
              )}
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Collapsable>
  );
};

export default CourseAgenda;
